var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('full-page',{ref:"fullpage",staticClass:"fullpage",attrs:{"options":_vm.fullpage,"id":"fullpage"}},[_vm._t("default")],2),(!_vm.isMobile)?_c('v-navigation',{attrs:{"is-visible":_vm.isVisible,"data":_vm.anchors}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }